module.exports = __webpack_public_path__ + "images/icons_v2/profile-outlined-4e5f9967.svg";